const AUTH_RETURN_PATH_KEY = 'auth-return-path'
const AUTH_EXPIRED_KEY = 'auth-session-expired'

const isSafeReturnPath = (path: string | null): path is string => (
  Boolean(path)
  && path!.startsWith('/')
  && !path!.startsWith('//')
  && !path!.startsWith('/login')
)

const currentReturnPath = () => {
  const path = `${window.location.pathname}${window.location.search}${window.location.hash}`
  return isSafeReturnPath(path) ? path : '/'
}

export const redirectToLogin = (reason: 'session_expired' = 'session_expired') => {
  if (window.location.pathname === '/login') return

  const returnPath = currentReturnPath()

  try {
    sessionStorage.setItem(AUTH_RETURN_PATH_KEY, returnPath)
    sessionStorage.setItem(AUTH_EXPIRED_KEY, '1')
  } catch {
    // The query parameters below still preserve the same context when storage is unavailable.
  }

  const params = new URLSearchParams({ reason, redirect: returnPath })
  window.location.replace(`/login?${params.toString()}`)
}

export const getLoginReturnPath = () => {
  const params = new URLSearchParams(window.location.search)
  const queryPath = params.get('redirect')
  if (isSafeReturnPath(queryPath)) return queryPath

  try {
    const storedPath = sessionStorage.getItem(AUTH_RETURN_PATH_KEY)
    if (isSafeReturnPath(storedPath)) return storedPath
  } catch {
    // Fall through to the default route.
  }

  return '/'
}

export const isSessionExpiredLogin = () => {
  const params = new URLSearchParams(window.location.search)
  if (params.get('reason') === 'session_expired') return true

  try {
    return sessionStorage.getItem(AUTH_EXPIRED_KEY) === '1'
  } catch {
    return false
  }
}

export const clearLoginRedirect = () => {
  try {
    sessionStorage.removeItem(AUTH_RETURN_PATH_KEY)
    sessionStorage.removeItem(AUTH_EXPIRED_KEY)
  } catch {
    // Nothing else is required when storage is unavailable.
  }
}
